import { render, staticRenderFns } from "./carbonEmission.vue?vue&type=template&id=0962e109&scoped=true&"
import script from "./carbonEmission.vue?vue&type=script&lang=js&"
export * from "./carbonEmission.vue?vue&type=script&lang=js&"
import style0 from "./carbonEmission.vue?vue&type=style&index=0&id=0962e109&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0962e109",
  null
  
)

export default component.exports